import React, { useState, useEffect } from "react";
import { ElectricLampContext } from "./context";

import { getElectricLamps } from "../services/services";

const ElectricLampProvider = ({ children }) => {
  const [ElectricLampData, setElectricLampData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchElectricLamps = async () => {
      const ElectricLamps = await getElectricLamps({ lang: "el" })
        .then((response) => {
          if (response) {
            setLoading(false);
            return response;
          } else {
            setLoading(false);
            return [];
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(error);
        });
      setElectricLampData(ElectricLamps);
    };

    fetchElectricLamps();
  }, []);

  return (
    <ElectricLampContext.Provider
      value={{
        ElectricLampsData: ElectricLampData,
        setElectricLampsData: setElectricLampData,
        loading,
        error,
      }}
    >
      {children}
    </ElectricLampContext.Provider>
  );
};

export default ElectricLampProvider;
